import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { SUBTABS, INTERPRET_STEPS, CHOOSE_STEPS } from './ConstPaths';
import TestDriveInterpretDeeper from './TestDriveInterpretDeeper';
import TestDriveInterpretChoose from './TestDriveInterpretChoose';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeAccessMethodCategory: PropTypes.string,
  activeTestDriveClientRating: PropTypes.string,
  activeTestDrivePractitionerRating: PropTypes.string,
  activeTestDriveIssuesNoted: PropTypes.arrayOf(PropTypes.string),
  activeTestDriveId: PropTypes.string,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeAccessMethodCategory: '',
  activeTestDriveClientRating: '',
  activeTestDrivePractitionerRating: '',
  activeTestDriveIssuesNoted: [],
};

//Manage the wizard form for the Test-drive / Interpret sub-tab
//Initialize the forms with props and manage those as local state.
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

//the steps of the wizard form:
const steps = INTERPRET_STEPS;

const BASE_URL = SUBTABS.INTERPRET + "/";
const START_NEW_TESTDRIVE = SUBTABS.CHOOSE + "/" + CHOOSE_STEPS.ACCESS_METHOD;
const NEXT_SECTION = SUBTABS.TEST_REVIEW;

class TestDriveInterpret extends React.Component {
  constructor(props) {
    super(props);

    //manage the variables that can be changed in this section - as local state
    this.state = {
      doAnotherTestDrive: ''
    };

    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/contexts/intro' would have step of 'intro'
    //props.match: {"step":"intro"}
    const stepParam = this.props.match.params.step;
    if(stepParam){
      return(stepParam);
    }
    else{
      return(steps.DEEPER);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  onContinue() {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const saveAndResetTestDrive = this.props.saveAndResetTestDrive;
    const curURL = new URL(window.location.href);


    switch(this.getCurrentStep()){
      case steps.DEEPER:
        nextStep = steps.CHOOSE;
        break;
      case steps.CHOOSE:
        nextStep = '';
        goToNextSection = true;
        //TODO we add the test-drive to the completed test-drives array here, and only here, 
        //so if you skip this step somehow, the test-drive won't be saved in the array
        //or if you visit twice, it'll save an extra empty test-drive.
        //For now, though, this seems to work OK as long as you do the normal workflow.
        saveAndResetTestDrive();
        break;
      default:
        console.log("   default next step");
        nextStep = steps.DEEPER;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      if(this.state.doAnotherTestDrive === 'true'){
        nextRoute = START_NEW_TESTDRIVE;
        this.props.updateSession('tempMessage', {
          icon:'success',
          title:'Starting a new Test-drive',
          label: '',
          message: 'Your data have been saved',
          duration: 5000
        });    
      }
      else
        nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }

  //the keys are the names of the local state variables, defined above in the constructor
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;
      
      console.log("Updating TestDriveInterpret state with key: " + key + " value: " + value);
      this.setState({ [key]: value });
    }
  }

  render() {
    console.log("rendering TestDriveInterpret, firstName: " + this.props.firstName);
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;
    const dev = this.props.dev;

    return(
    <>
    <Switch>
      <Route path={BASE_URL+ steps.DEEPER}>
        <TestDriveInterpretDeeper
          key={steps.DEEPER}
          firstName={firstName}
          pronouns={pronouns}
          onContinue={this.onContinue}
          activeAccessMethodCategory={this.props.activeTestDrive.activeAccessMethodCategory}
          activeTestDriveClientRating={this.props.activeTestDrive.activeTestDriveClientRating}
          activeTestDrivePractitionerRating={this.props.activeTestDrive.activeTestDrivePractitionerRating}
          activeTestDriveIssuesNoted={this.props.activeTestDrive.activeTestDriveIssuesNoted}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.CHOOSE}>
        <TestDriveInterpretChoose
          key={steps.CHOOSE}
          firstName={firstName}
          pronouns={pronouns}
          onContinue={this.onContinue}
          doAnotherTestDrive={this.state.doAnotherTestDrive}
          onChangeDoAnotherTestDrive={this.updateLocalState("doAnotherTestDrive")}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.DEEPER + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

TestDriveInterpret.propTypes = propTypes;
TestDriveInterpret.defaultProps = defaultProps;

// withRouter wrapper provides access to the match, location, and history props (used in onContinue)
export default withRouter(TestDriveInterpret);
